
import React from 'react';
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { ImageUploader } from "./ImageUploader";

interface GameFormFieldsProps {
  gameName: string;
  previewUrl: string | null;
  isEditMode: boolean;
  currentGameCoverUrl: string | null;
  disabled: boolean;
  onNameChange: (name: string) => void;
  onFileChange: (file: File | null) => void;
  onPreviewChange: (url: string | null) => void;
}

export const GameFormFields: React.FC<GameFormFieldsProps> = ({
  gameName,
  previewUrl,
  isEditMode,
  currentGameCoverUrl,
  disabled,
  onNameChange,
  onFileChange,
  onPreviewChange
}) => {
  return (
    <div className="space-y-6">
      <div className="space-y-2">
        <Label htmlFor="name" className="text-white">Nome do Jogo</Label>
        <Input
          id="name"
          value={gameName}
          onChange={(e) => onNameChange(e.target.value)}
          className="bg-[#242C37] border-[#2A3749] text-white focus-visible:ring-[#00B6F0]"
          placeholder="Nome do jogo"
          required
          disabled={disabled}
        />
      </div>
      
      <ImageUploader
        previewUrl={previewUrl}
        isEditMode={isEditMode}
        currentGameCoverUrl={currentGameCoverUrl}
        disabled={disabled}
        onFileChange={onFileChange}
        onPreviewChange={onPreviewChange}
      />
    </div>
  );
};
